import React  from 'react';
import {FieldViewProps} from "../../../render/view";
import FieldRAG_Icon from "../components/rag-icon";

export default function FieldRAG_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)
    const option = props.field._getOption(value)


    return <FieldRAG_Icon option={option} />
}
